import { useEffect } from 'react';

import { useAnalytics } from 'shared/hooks/analytics';
import { useUserRole } from 'shared/hooks/user';

export const useAnalyticsRegisterUser = () => {
  const analytics = useAnalytics();
  const userRole = useUserRole();

  useEffect(() => {
    // TODO: change register props when requirements will be ready
    analytics.register({
      user: { role: userRole },
    });
  }, [analytics, userRole]);
};
